var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imgList.length > 0)?_c('div',{staticClass:"animation-group",class:_vm.animationClass},_vm._l((_vm.imgList),function(imgObj,idx){return _c('div',{key:idx,staticClass:"animation-group__item g-item",class:_vm.playAni && 'ani-x',style:({
      left: _vm.$pxToVw(imgObj.left),
      top: _vm.$pxToVw(imgObj.top),
      right: _vm.$pxToVw(imgObj.right),
      bottom: _vm.$pxToVw(imgObj.bottom),
      width: _vm.$pxToVw(imgObj.width),
      height: _vm.$pxToVw(imgObj.height),
      animationDelay: idx * 0.088 + 's',
      transitionDelay: idx * 0.07 + 's',
    })},[_c('van-image',{staticClass:"animation-group__item-inner g-inner",class:_vm.playAni && 'ani-y',style:({
        animationDelay: idx * 0.088 + 's',
        transitionDelay: idx * 0.07 + 's',
      }),attrs:{"src":imgObj.src,"width":_vm.$pxToVw(imgObj.size) || 64}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }